import React from 'react';
import { useNavigate } from 'react-router-dom';

import { SvgCardType } from '../../components/svg-card/svg-card-types';
import { useConfig } from '../../config';
import { urler } from '../../router/router-urler';
import { RadioAlternativ } from '../../sporsmalsflyt/reducer/sporsmalsflyt-types';
import { Skademeldingstype } from '../../types/generated-types';
import { navigateToSitecorePage, skadeUrlFromSkadetype } from '../../urler';
import { GruppeLandingsside } from '../gruppe-landingsside';
import { KategoriSvarId } from '../sporsmal-og-svar';

const { bygningNaturskadeUrl, bygningBrannOgElektriskeSkaderUrl, bygningInnbruddOgHarverkSkaderUrl } = urler();

const alternativer: RadioAlternativ[] = [
    {
        id: KategoriSvarId.BygningLekkasjeOgVannskader,
        tekst: 'Lekkasjer og vannskader',
    },
    {
        id: KategoriSvarId.BygningBrannOgElektriskeSkader,
        tekst: 'Brann og elektriske skader',
    },
    {
        id: KategoriSvarId.BygningGlasskade,
        tekst: 'Glasskade',
    },
    {
        id: KategoriSvarId.BygningInnbruddOgHarverk,
        tekst: 'Innbrudd og hærverk',
    },
    {
        id: KategoriSvarId.BygningSoppRateOgSkadedyr,
        tekst: 'Sopp, råte og skadedyr',
    },
    {
        id: KategoriSvarId.BygningNaturskade,
        tekst: 'Naturskade',
    },
    {
        id: KategoriSvarId.BygningAnnet,
        tekst: 'Annen bygning og eiendomsskade',
    },
];

export const Bygning = () => {
    const { url } = useConfig().links.husoghyttelandingsside;
    const navigate = useNavigate();

    const onNext = (svarId: string) => {
        if (svarId === KategoriSvarId.BygningLekkasjeOgVannskader) {
            navigate(urler().bygningLekkasjerOgVannskaderUrl);
        } else if (svarId === KategoriSvarId.BygningBrannOgElektriskeSkader) {
            navigate(bygningBrannOgElektriskeSkaderUrl);
        } else if (svarId === KategoriSvarId.BygningGlasskade) {
            navigate(urler().bygningGlasskadeUrl);
        } else if (svarId === KategoriSvarId.BygningInnbruddOgHarverk) {
            navigate(bygningInnbruddOgHarverkSkaderUrl);
        } else if (svarId === KategoriSvarId.BygningSoppRateOgSkadedyr) {
            navigate(urler().soppRateSkadedyr);
        } else if (svarId === KategoriSvarId.BygningNaturskade) {
            navigate(bygningNaturskadeUrl);
        } else if (svarId === KategoriSvarId.BygningAnnet) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.BygningAnnet));
        }
    };

    return (
        <GruppeLandingsside
            title="Hus og hytte"
            onNext={onNext}
            radioButtonsLabel="Hva gjelder det?"
            navigateToParent={() => navigateToSitecorePage(url)}
            alternativer={alternativer}
            svgCardType={SvgCardType.HusEnkelt}
            kategoriId="bygning"
        />
    );
};
